export * from './exports';
import { unstable_batchedUpdates as batch } from './utils/reactBatchedUpdates';
import { setBatch } from './utils/batch'; // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(batch);
export { batch };


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/index.js
// module id = RH2O
// module chunks = 0